<template>
  <div>
    <div class="carousel__container">
      <a-carousel autoplay fade>
        <!-- <div v-for="item in carouselImage" :key="item.id">
          <a-row class="carousel__body">
            <a-col :span="13" class="carousel__col1">
              <img class="carousel__imgleft" :src="item.image_url1" />
              <div class="carousel__text">
                <span>{{ item.header1 }}</span>
                <span>{{ item.sub_header1 }}</span>
              </div>
            </a-col>
            <a-col :span="9" class="carousel__col2">
              <div class="carousel__image1parent">
                <img class="carousel__imgright1" :src="item.image_url2" />
                <div class="carousel__textrightimg1">
                  <span>{{ item.header2 }}</span>
                  <span>{{ item.sub_header2 }}</span>
                </div>
              </div>

              <div class="carousel__image1parent">
                <img class="carousel__imgright2" :src="item.image_url3" />
                <div class="carousel__textrightimg1">
                  <span>{{ item.header3 }}</span>
                  <span>{{ item.sub_header3 }}</span>
                </div>
              </div>
            </a-col>
          </a-row>
        </div> -->
        <!-- <div v-for="item in modifiedCarousel" :key="item.id">
          <a-row class="carousel__body">
            <span>
              <a-col :span="13" class="carousel__col1">
                <img class="carousel__imgleft" :src="item.image_url1" />
                <div class="carousel__text">
                  <span> item.header1 </span>
                  <span> item.sub_header1 </span>
                </div>
              </a-col>
            </span>

            <a-col :span="9" class="carousel__col2">
              <span>
                <div class="carousel__image1parent">
                  <img class="carousel__imgright1" :src="item.image_url2" />
                  <div class="carousel__textrightimg1">
                    <span>item.header2 </span>
                    <span> item.sub_header2 </span>
                  </div>
                </div>
              </span>

              <span>
                <div class="carousel__image1parent">
                  <img class="carousel__imgright2" :src="item.image_url3" />
                  <div class="carousel__textrightimg1">
                    <span>item.header3 </span>
                    <span> item.sub_header3</span>
                  </div>
                </div>
              </span>
            </a-col>
          </a-row>
        </div> -->

        <!-- /*
  First ma single column


  2nd and 3rd are in 2nd column
   */ -->
      </a-carousel>
    </div>

    <div class="carousel__mobile">
      <a-carousel autoplay fade class="carousel__mobilebody">
        <a-col
          v-for="(i, boxNo) in Math.ceil(carouselImages.length / 3)"
          :key="boxNo + 'CarousalYo'"
        >
          <a-row
            class="carousel__mobilerow"
            type="flex"
            justify="center"
            v-for="(j, itemNo) in 3"
            :key="i + j + 'item'"
          >
            <a-col
              :span="23"
              v-if="
                Number(3 * boxNo + itemNo) % 3 == 0 ||
                Number(3 * boxNo + itemNo) == 0
              "
            >
              <div
                :style="{ position: 'relative', marginLeft: '2vw' }"
                v-if="Number(3 * boxNo + itemNo) < carouselImages.length"
              >
                <img
                  class="carousel__mobileImageTop"
                  :src="carouselImages[Number(3 * boxNo + itemNo)].image"
                  loading="eager"
                  @click="
                    handleSearch(
                      carouselImages[Number(3 * boxNo + itemNo)]
                        .redirection_code
                    )
                  "
                />
                <div class="carousel__mobileText">
                  <span>{{
                    carouselImages[Number(3 * boxNo + itemNo)].title
                  }}</span>
                  <span>
                    {{ carouselImages[Number(3 * boxNo + itemNo)].details }}
                  </span>
                </div>
              </div>
            </a-col>
          </a-row>

          <a-row type="flex" justify="center">
            <a-col
              :span="22"
              class="carousel__mobilecol2"
              :style="{
                position: 'relative',
                display: 'flex',
                flexDirectin: 'row',
              }"
            >
              <div
                :style="{
                  position: 'relative',
                }"
                v-for="(j, itemNo) in 3"
                :key="i + j + 'item'"
              >
                <span v-if="Number(3 * boxNo + itemNo) % 3 != 0">
                  <div
                    v-if="Number(3 * boxNo + itemNo) < carouselImages.length"
                    :style="{
                      display: 'flex',
                      flexDirectin: 'row',
                    }"
                  >
                    <img
                      class="carousel__mobileImageDown1"
                      :src="carouselImages[Number(3 * boxNo + itemNo)].image"
                      loading="eager"
                      @click="
                        handleSearch(
                          carouselImages[Number(3 * boxNo + itemNo)]
                            .redirection_code
                        )
                      "
                    />

                    <div class="carousel__mobileTextBottom">
                      <span>{{
                        carouselImages[Number(3 * boxNo + itemNo)].title
                      }}</span>
                      <span>
                        {{ carouselImages[Number(3 * boxNo + itemNo)].details }}
                      </span>
                    </div>
                  </div>
                </span>
              </div>
            </a-col>

            <!-- <a-col :span="11" class="carousel__mobilecol2">
              <div :style="{ position: 'relative' }">
                <img
                  class="carousel__mobileImageDown1"
                  :src="require('../../../assets/carousel/pizza.jpg')"
                />
                <div class="carousel__mobileTextBottom">
                  <span>Amazing 50-50 Pizza</span>
                  <span>Our 50-50 pizza are the best in the town.</span>
                </div>
              </div>
            </a-col> -->
          </a-row>
        </a-col>
      </a-carousel>
    </div>

    <!-- test carousal -->

    <div class="carousel__container">
      <a-carousel autoplay fade>
        <a-row
          class="carousel__body"
          v-for="(i, boxNo) in Math.ceil(carouselImages.length / 3)"
          :key="boxNo + 'CarousalYo'"
        >
          <div v-for="(j, itemNo) in 3" :key="i + j + 'item'">
            <a-col
              v-if="
                Number(3 * boxNo + itemNo) % 3 == 0 ||
                Number(3 * boxNo + itemNo) == 0
              "
              :span="11"
              class="carousel__col1"
            >
              <!-- ||{{ 3*boxNo + itemNo }}   || -->

              <div
                class="carousel__image1parent"
                v-if="Number(3 * boxNo + itemNo) < carouselImages.length"
                @click="
                  handleSearch(
                    carouselImages[Number(3 * boxNo + itemNo)].redirection_code
                  )
                "
              >
                <img
                  class="carousel__imgleft"
                  :src="carouselImages[Number(3 * boxNo + itemNo)].image"
                  loading="eager"
                />
                <div class="carousel__text">
                  <span>{{
                    carouselImages[Number(3 * boxNo + itemNo)].title
                  }}</span>
                  <span>
                    {{ carouselImages[Number(3 * boxNo + itemNo)].details }}
                  </span>
                </div>
              </div>
            </a-col>
          </div>

          <a-col :span="9" class="carousel__col2">
            <!-- **{{ 3*boxNo + itemNo }} ** -->

            <div v-for="(j, itemNo) in 3" :key="i + j + 'item'">
              <span v-if="Number(3 * boxNo + itemNo) % 3 != 0">
                <div
                  @click="
                    handleSearch(
                      carouselImages[Number(3 * boxNo + itemNo)]
                        .redirection_code
                    )
                  "
                  class="carousel__image1parent"
                  v-if="Number(3 * boxNo + itemNo) < carouselImages.length"
                >
                  <!-- @click="
                      getRedirectionType(
                        carouselImages[Number(3 * boxNo + itemNo)]
                          .redirection_code,
                        carouselImages[Number(3 * boxNo + itemNo)]
                          .redirection_type
                      )
                    " -->
                  <img
                    class="carousel__imgright1"
                    :src="carouselImages[Number(3 * boxNo + itemNo)].image"
                    loading="eager"
                  />
                  <div class="carousel__textrightimg1">
                    <span>{{
                      carouselImages[Number(3 * boxNo + itemNo)].title
                    }}</span>
                    <span>
                      {{ carouselImages[Number(3 * boxNo + itemNo)].details }}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </a-col>
        </a-row>
        <!-- eoa-row -->
      </a-carousel>
    </div>
    <!-- eo carousel__container -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetBannerService } from "../../../services/items.service";
import { LocationId } from "../../../services/storage.service";
import router from "../../../router";

export default {
  name: "Carousel",
  data() {
    return {
      carouselImages: [],
    };
  },

  computed: {
    ...mapGetters(["locationId", "currentLocation"]),
  },

  created() {
    this.loadCarousel();
  },

  watch: {
    currentLocation() {
      this.loadCarousel();
    },
  },

  methods: {
    loadCarousel() {
      this.currentTag = this.$route.params.slug;
      if (this.currentTag == undefined) this.currentTag = "";
      // alert("carousel function run");

      GetBannerService.getItems(LocationId.getLocationId(), this.currentTag)
        .then((response) => {
          // let banner = response.data.filter((data) => data.type === "banner");
          // this.bannerItems = banner;
          // this.imagesloaded = 1;

          const filterBanner = response.data.filter(
            (banner) => banner.type === "banner"
          );

          this.carouselImages = filterBanner;
          // this.carouselImages = response.data;

          // console.log(
          //   this.carouselImages,
          //   " carousel images from state carousel"
          // );
        })
        .catch((err) => console.log(err));
    },

    //  window.open(
    //       `https://khaanpin.com.np/infeed/#/cif?t=${token}&c=${code}`,
    //       "_blank"
    //     );

    getSubmenu(redirect) {
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/c/" + redirect);
        window.open(`/ktm/c/${redirect}`, "_blank");
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/c/" + redirect);
        window.open(`/pkr/c/${redirect}`, "_blank");
      }
    },

    reDirectList() {
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/l/" + redirect);
        window.open(`/ktm/l/${redirect}`, "_blank");
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/l/" + redirect);
        window.open(`/pkr/${redirect}`, "_blank");
      }
    },

    reDirectItem() {
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/i/" + redirect);
        window.open(`/ktm/i/${redirect}`, "_blank");
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/i/" + redirect);
        window.open(`/pkr/i/${redirect}`, "_blank");
      }
    },

    // reDirectUrl(redirect) {
    //   if (LocationId.getLocationId() == 1) {
    //     window.open(`/ktm/l/${redirect}`, "_blank");

    //   } else if (LocationId.getLocationId() == 2) {
    //     window.open(`/pkr/l/${redirect}`, "_blank");

    //   }
    // },

    getRedirectionType(redirection_code, redirection_type) {
      // alert(redirection_code);
      if (redirection_type === "search") {
        this.handleSearch(redirection_code);
      } else if (redirection_type === "section") {
        this.getSubmenu(redirection_code);
      } else if (redirection_type === "list") {
        this.reDirectList(redirection_code);
      } else if (redirection_type === "item") {
        this.reDirectItem(redirection_code);
      } else if (redirection_type === "url") {
        this.reDirectUrl(redirection_code);
      }
    },

    handleSearch: function (redirect) {
      // console.log(redirect, "hello redirect")
      if (redirect == "") {
        return;
      }
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: redirect },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: redirect },
        });
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.carousel__container {
  /* width: 80%;
   display: flex;
  justify-content: center;  */
  /* border: 1px solid black; */
  /* overflow: hidden; */
  margin-bottom: 60px;
  margin-top: -28px;
}

.carousel__body {
  margin: 0 0 15px 10%;
  height: 510px;
  /* border : 2px solid black; */

  /* display: flex;
justify-content: center; */
}

.carousel__col1 {
  position: relative;
  /* border: 1px solid black; */
}

.carousel__text {
  position: absolute;
  bottom: 0%;
  left: -0%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* border: 1px solid white; */
  /* background-color: red; */
  width: 97%;
  padding: 1% 2% 2% 0%;
  /* padding-bottom: 1% ; */
  border-radius: 10px;
  font-family: "Montserrat", sans-serif;
  background-image: linear-gradient(transparent, rgb(0, 0, 0), rgb(5, 5, 5));
  /* border: 1px solid red; */
}
.carousel__text > span:nth-child(1) {
  font-size: 33px;
  font-weight: bolder;
  letter-spacing: 1px;
}

.carousel__text > span:nth-child(2) {
  font-size: 18px;
  font-weight: bolder;
  letter-spacing: 0.8px;
}

.carousel__image1parent {
  position: relative;
}

.carousel__image1parent > img {
  cursor: pointer;
}

.carousel__textrightimg1 {
  width: 97%;
  position: absolute;
  bottom: 0%;
  /* right: 0%; */
  color: white;
  border-radius: 10px;
  display: flex;
  /* background: red; */
  flex-direction: column;
  align-items: flex-end;
  /* border: 1px solid white; */
  padding: 2% 1% 2% 1%;

  font-family: "Montserrat", sans-serif;
  background-image: linear-gradient(
    transparent,
    rgba(20, 20, 20, 0.945),
    rgb(5, 5, 5)
  );
}

.carousel__textrightimg1 > span:nth-child(1) {
  font-size: 26px;
  font-weight: bolder;
  letter-spacing: 1px;
}

.carousel__textrightimg1 > span:nth-child(2) {
  font-size: 13px;
  font-weight: bolder;
  letter-spacing: 0.8px;
}

/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  /* display: flex; */
  /* justify-content: center; */
  /* height: 540px; */
  /* line-height: 160px; */
  /* background: pink; */
  /* width: 80%; */
  /* border: 1px solid red; */
  /* margin-left: 4rem; */
  /* margin-right: 5rem; */

  /* display: flex; */
  /* overflow: hidden; */
}

.ant-carousel >>> .slick-dots li button {
  /* position: static; */
  /* margin-top: 20px; */
  width: 10px;
  height: 10px;
  border-radius: 20px;
  background-color: grey;
}

.ant-carousel >>> .slick-dots li.slick-active button {
  width: 10px;
  height: 10px;
  /* border-radius: 100%; */
  background: red;
}

.carousel__main {
  display: flex;
}

.carousel__imgleft {
  border-radius: 10px;
  /* padding-right: 10px; */
  object-fit: cover;
  /* border: 1px solid black; */
  height: 483px;
  width: 97%;
  /* padding-right: 100px; */
}
.carousel__imgright1 {
  width: 97%;
  border-radius: 10px;
  object-fit: cover;
  height: 230px;
  margin-bottom: 23px;
  /* width: 100%; */
}

.carousel__imgright2 {
  width: 100%;
  border-radius: 10px;
  /* margin-top: 20px; */
  object-fit: cover;
  height: 230px;
  /* width: 100%; */
}

.col1 {
  /* border: 1px solid black; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 10px; */
  min-height: 50vh;
  /* border: 1px solid black;
  /* color: green; */
}

@media only screen and (max-width: 1300px) {
  .carousel__textrightimg1 {
    width: 100%;
  }

  .carousel__imgleft {
    border-radius: 10px;
    object-fit: cover;
    height: 413px;
    width: 97%;
  }
  .carousel__imgright1 {
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
    height: 200px;
    margin-bottom: 13px;
  }

  .carousel__imgright2 {
    width: 100%;
    border-radius: 10px;
    margin-top: 20px;
    object-fit: cover;
    height: 180px;
  }
  .carousel__body {
    height: 420px;
  }
  .carousel__text > span:nth-child(1) {
    font-size: 24px;
    font-weight: bolder;
  }

  .carousel__text > span:nth-child(2) {
    font-size: 12px;
    font-weight: bolder;
    letter-spacing: 0.8px;
  }
  .carousel__textrightimg1 > span:nth-child(1) {
    font-size: 20px;
    font-weight: bolder;
  }

  .carousel__textrightimg1 > span:nth-child(2) {
    font-size: 8px;
    font-weight: bolder;
  }
}

@media only screen and (max-width: 800px) {
  .ant-carousel >>> .slick-dots li button {
    width: 8px;
    height: 8px;
  }

  .ant-carousel >>> .slick-dots li.slick-active button {
    width: 8px;
    height: 8px;
  }

  .carousel__container {
    display: none;
  }
  .ant-carousel >>> .slick-slide {
    margin-bottom: 20px;
  }
  .carousel__mobile {
    /* background: red;  */
    /* min-height: 50vh; */
    margin: 0 4% 0 6%;
  }

  .carousel__mobileImageTop {
    height: 10%;
    width: 97%;
    object-fit: cover;
    border-radius: 15px;
  }

  .carousel__mobileText {
    position: absolute;
    bottom: 0%;
    color: white;
    /* right: 0%; */
    padding: 1.5% 3% 1% 0;
    font-family: "Montserrat", sans-serif;
    /* border: 1px solid white; */
    width: 97%;
    border-radius: 15px;
    /* background: red; */
    display: flex;
    /* background: red; */
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(transparent, rgb(0, 0, 0), rgb(5, 5, 5));
  }

  .carousel__mobileText > span:nth-child(1) {
    font-size: 20px;
    font-weight: bolder;
  }

  .carousel__mobileText > span:nth-child(2) {
    font-size: 10px;
    font-weight: bolder;
    text-align: center;
  }

  .carousel__mobilecol2 {
    margin: 8px 4px 0 4px;
  }
  .carousel__mobileImageDown1 {
    width: 41.5vw;
    height: 25vw;
    object-fit: cover;
    border-radius: 18px;
    padding-right: 10px;
    /* padding: 6% 3% 0 3%; */
  }
  .carousel__mobileTextBottom {
    position: absolute;
    bottom: 0%;
    color: white;
    /* right: 1%; */
    overflow: hidden;
    padding: 6% 1% 3% 3%;
    /* padding-right: 2px; */

    font-family: "Montserrat", sans-serif;

    /* border: 1px solid white; */
    width: 40vw;
    border-radius: 10px;
    /* background: red; */
    display: flex;
    /* background: red; */
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      transparent,
      rgba(0, 0, 0, 0.863),
      rgb(5, 5, 5)
    );
  }
  .carousel__mobileTextBottom > span:nth-child(1) {
    font-size: 12px;
    font-weight: bolder;
    font-family: "Montserrat", sans-serif;
  }

  .carousel__mobileTextBottom > span:nth-child(2) {
    font-size: 4px;
    font-weight: bolder;
    text-align: center;
    font-family: "Montserrat", sans-serif;
  }
}

@media only screen and (max-width: 650px) {
  .carousel__mobileTextBottom {
    width: 39.6vw;
  }
}

@media only screen and (max-width: 463px) {
  .carousel__mobileTextBottom {
    width: 93.6%;
  }
}
@media only screen and (min-width: 800px) {
  .carousel__mobile {
    display: none;
  }
}
</style>
